import type {
  Product,
  PromotionResponse,
} from "vacv-common/src/types/api/promotion/Api";

export type Language = "en" | "fr";
export type Locale = "en-CA" | "fr-CA";
export enum VacationType {
  PACKAGE = "PACKAGE",
  TOUR = "TOUR",
  HOTEL = "HOTEL",
}

export interface PromotionResponseExtended extends PromotionResponse {
  products: Array<ProductExtended> | undefined;
}
export interface ProductExtended extends Product {
  price_formatted: string;
  hotel_details_link: string;
  index: number;
  _id: string;
}

export interface DataLayerHotelClickResult {
  event: string;
  ecommerce: object;
}

export interface PromosInputParams {
  tripMonth: string;
  leaveFrom: string;
  goTo: string;
  duration: string;
  targetedHotelList: string;
  userSessionAlias: string;
  promoSearchLang: string;
  promoStartDate: string;
  promoEndDate: string;
  promotionId: string;
}

export interface PromosOutputParams {
  year_month?: string;
  gateway?: string;
  destination?: string;
  duration?: string;
  starRating?: string;
  targeted_hotel_list?: string;
  alias?: string;
  lang?: string;
  promo_start_date?: string;
  promo_end_date?: string;
  promotion_id?: string;
  priceCap?: string;
}

export interface PromosOption {
  code: string;
  label: string;
  sr?: string;
}

export interface PromosCMSParams {
  defaultDestination: string;
  defaultGateway: string;
  defaultDepartureMonth: string;
  defaultDuration: string;
  destinations: PromosOption[];
  durations: string[];
  starRating: string;
  gateways: PromosOption[];
  months: PromosOption[];
  promoSearchLang: string;
  promo_booking_start: string;
  promo_booking_end: string;
  promo_id: string;
  promo_path: string;
  promo_travel_start: string;
  promo_travel_end: string;
  vacationType: VacationType;
  targetedHotelList: string;
  alias: string;
  priceCap: string;
}

export interface PromosSettings {
  destination?: string;
  gateway?: string;
  month?: string;
  duration?: string;
  starRating?: string;
  priceCap?: string;
  starRatingOptions: PromosOption[];
  destinationOptions: PromosOption[];
  durationOptions: string[];
  gatewayOptions: PromosOption[];
  monthOptions: PromosOption[];
  promoSearchLang: string;
  promoBookingEnd: string;
  promoBookingStart: string;
  promoId: string;
  promoPath: string;
  promoTravelEnd: string;
  promoTravelStart: string;
  targetedHotelList: string;
  alias: string;
  vacationType: VacationType;
}

export type SortIdOption = "price" | "departure-date" | "star-rating";
export type SortOrderOption = "asc" | "desc";
